
import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import { store } from "@/store/store";

const processUserUpdate = ( { body, } ) => {
	const localPersonId = store.getters[ "userProfile/personId" ];
	if ( body.personId === localPersonId ) {
		store.dispatch( "userProfile/reloadUserProfile" );
	}
};

export const initWebSocketListeners = () => {
	addSocketMessageListener( SocketMessageType.USER_UPDATED, processUserUpdate );
};



// WEBPACK FOOTER //
// ./src/store/modules/userProfile/userApiOrchestrator.js